import {
  CREATE_SUBSCRIPTION, GET_SUBSCRIPTIONS, UPDATE_SUBSCRIPTIONS,
} from '../actionTypes';

const initialState = {
  subsSuccess: false,
  message: '',
  error: false,
  isLoading: false,
  subscriptions: [],

  updated: false,
  isLoadingUpdate: false,
};

export default function reducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case `${CREATE_SUBSCRIPTION}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        subsSuccess: false,
      };
    case `${CREATE_SUBSCRIPTION}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
        subsSuccess: false,
      };
    case `${CREATE_SUBSCRIPTION}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        subsSuccess: true,
      };

    case `${GET_SUBSCRIPTIONS}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        updated: false,
      };
    case `${GET_SUBSCRIPTIONS}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${GET_SUBSCRIPTIONS}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        subscriptions: payload.data.data,
      };

    case `${UPDATE_SUBSCRIPTIONS}_PENDING`:
      return {
        ...state,
        isLoadingUpdate: true,
        error: false,
        updated: false,
      };
    case `${UPDATE_SUBSCRIPTIONS}_REJECTED`:
      return {
        ...state,
        isLoadingUpdate: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${UPDATE_SUBSCRIPTIONS}_FULFILLED`:
      return {
        ...state,
        isLoadingUpdate: false,
        error: false,
        message: '',
        updated: true,
      };

    default:
      return state;
  }
}
